import JSEncrypt from 'jsencrypt'

function make_ciphertext(plaintext) {
    var encryptor = new JSEncrypt()
    var pubKey =  `-----BEGIN PUBLIC KEY-----
MFswDQYJKoZIhvcNAQEBBQADSgAwRwJAdWnnOffxB6nlsttZk4E65xqz2jwl/ws8
LiAnmbvi7No2c4FuFU5SY/X+Q3letj1yjEicPF37JAr/KAMRkTctLwIDAQAB
-----END PUBLIC KEY-----`
    encryptor.setPublicKey(pubKey)
    return encryptor.encrypt(plaintext)
}

export {make_ciphertext}